module.exports = __webpack_public_path__ + "img/invite_banner.3c552fe9.png";